export const dhlIllustrationStyles = {
  '.DhlIllustration-root': {
    userSelect: 'none',
    display: 'inline-flex',
    flexShrink: 0,
  },

  '.DhlIllustration-disabled': {
    filter: 'saturate(0)',
  },

  '.DhlIllustration-XXS': {
    maxWidth: 84,
  },

  '.DhlIllustration-XS': {
    maxWidth: 120,
  },

  '.DhlIllustration-S': {
    maxWidth: 168,
  },

  '.DhlIllustration-M': {
    maxWidth: 240,
  },

  '.DhlIllustration-L': {
    maxWidth: 360,
  },

  '.DhlIllustration-XL': {
    maxWidth: 480,
  },
}
